import api from '@app/apis';
import type { QuickEstimatePayload, QuickEstimateResponse } from '@app/types/quick-estimate';
import logger from '@app/utils/logger';

export const QUICK_ESTIMATE_PATH = '/rental-order-service/rental/equipment-availability';

export async function submitQuickEstimate(
  payload: QuickEstimatePayload,
): Promise<QuickEstimateResponse> {
  try {
    const { data } = await api.post<QuickEstimateResponse>(QUICK_ESTIMATE_PATH, payload);
    return data;
  } catch (error) {
    logger('error', 'at submitQuickEstimate while submitting equipment availability request');
    throw error;
  }
}
